import { useEffect, useState, useCallback, useRef } from "react";
import "./RoleName.css";
import "../OptionBlocks.css";
import {
  JustifiedAlignment3,
  LeftAlignment2,
  RaggedAlignment,
  RightAlignment2,
  DoubleColumn,
  SingleColumn,
  RoleFirst,
  NamesFirst,
  SideAB,
  InsetOff,
  InsetLeft,
  InsetRight,
  gutterJustify,
  SingleColumnCenter,
} from "../../../../../assets/icons/index";

import {
  NumberInput,
  Radio,
  Dropdown,
  NumberInput_fontsize,
} from "../../../../../Components";

import {
  updateProjectCreditOptionsState,
  saveOptionById,
  updateFontStyleState,
  saveFontStyle,
} from "../../../../../Redux/actions/projectActions";

import {
  Heading,
  Subheading,
} from "../../../../ProjectV2/Options/OptionFont/Functions";

import { useDispatch, useSelector } from "react-redux";

const initialOptions = [
  { label: "None", value: 0 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
];

const RoleName = ({
  options,
  currentBlockIdx,
  currentBlockId,
  undoStack,
  isCard,
}) => {
  const dispatch = useDispatch();

  const [selectedID, setSelectedID] = useState("");
  const [option, setOptions] = useState([...initialOptions]);

  // GET CURRENT BLOCK
  const { credits, currentBlock } = useSelector((state) => state?.project ?? {});

  const currentBlockData = credits?.find(
    (block, index) =>
      index === currentBlock?.idx &&
      block?._id === currentBlock?.id
  );

  const currentBlockType = currentBlockData?.options?.block_type || options?.block_type || "rolename";
  const fontStyle = useSelector((state) => state?.project?.fontStyle?.name ?? {});
  const fontStyleType =  currentBlockType === "nameonly"  ? "nameOnlyStyle" : "name";
  const fontStyleTypeRef = useRef(fontStyleType);

  useEffect(() => {
    fontStyleTypeRef.current = fontStyleType;
  }, [fontStyleType]);

  // UPDATE FONT STYLE IN REDUX
  const updateFontState = useCallback((key, value) => {
      dispatch( updateFontStyleState( fontStyleType,  key,  value,  currentBlockType  ) );
    }, [ dispatch, fontStyleType, currentBlockType]
  );

  // DEBOUNCED SAVE
  const debounceTimeoutIds = useRef({});

  const debouncedSave = useCallback((key, value, targetType) => {
      const saveType =  targetType || fontStyleType;
      const timerKey = `${saveType}:${key}`;

      // Clear previous timer
      if (debounceTimeoutIds.current[timerKey]) {
        clearTimeout(debounceTimeoutIds.current[timerKey]);
      }

      // Create new timer
      debounceTimeoutIds.current[timerKey] = setTimeout(async () => {
          try {
            await dispatch(saveFontStyle(saveType, currentBlockType, key, value, null, isCard));
          } catch (error) {
            console.error("Failed to save font style:", error);
          }
        }, 1000);
    }, [dispatch, fontStyleType, currentBlockType, isCard,]
  );

  // CLEANUP DEBOUNCE
  useEffect(() => {
    return () => {
      Object.values(debounceTimeoutIds.current).forEach((timer) => {
        if (timer) {
          clearTimeout(timer);
        }
      });
    };
  }, []);

  // SAVE FONT IMMEDIATELY
  const saveFonts = useCallback(
    async (key, value) => {
      try {
        await dispatch(saveFontStyle( fontStyleType, currentBlockType, key, value, null, isCard));
      } catch (error) {
        console.error("Failed to save font style:", error);
      }
    },
    [ dispatch, fontStyleType, currentBlockType, isCard ]
  );

  const handleMarginBottomChange = useCallback((val) => {
      // console.log('handleMarginBottomChange value => ', val);
      // Convert to Number
      const num = Number(val);
      if (Number.isNaN(num)) {
        return;
      }
      // Clamp between 0 and 30
      const clampedValue = Math.min( Math.max(num, 0), 30);
      // Update Redux immediately
      updateFontState( "marginBottom",  clampedValue );
      // Save to backend after 1 second
      debouncedSave( "marginBottom",  clampedValue,  fontStyleType );
    }, [updateFontState, debouncedSave, fontStyleType]
  );

  const handleChange = (key, value) => {
    switch (key) {
      case "columns": {
        const newColumns = Number(value);
        const newColumnWidth = Math.floor(100 / newColumns);
        dispatch(updateProjectCreditOptionsState( currentBlockIdx, "column_width", newColumnWidth));
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
        break;
      }
      default:
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
    }
  };

  const conditionalColumnWidth = (val, currentOptions) => {
    const columns = Number(currentOptions?.columns || 1);
    const max = 100 / columns;
    return parseInt(val > 0 ? val < max + 1 ? val : max : 0, 10);
  };

  const saveOptions = () => {
    if (undoStack) {
      undoStack.push(options);
    }
    dispatch(saveOptionById(currentBlockId, isCard));
  };

  const getValue = (value) => {
    return value ?? "";
  };

  useEffect(() => {
    const idx = option.findIndex(
      (opt) => opt.value === options?.margin_vertical,
    );

    if (idx !== -1) {
      setSelectedID(idx);
    }
  }, [options?.margin_vertical, option]);

  return (
    <div className="Roles-name">
      <div className="rolename-inside">
        <div className=" border-b-[1px] border-[#ffffff0e] pb-3 ">
          <div className="pt-[12px]">
            <div className="w-full font-body font-medium text-[13px] text-white">
              Heading
            </div>
            <div className="w-full h-[46px] pt-1 rounded-2xl">
              <Heading
                onChange={(val) => {
                  handleChange("heading", val);
                }}
                value={getValue(options?.heading)}
                onFocusOut={saveOptions}
              />
            </div>
          </div>

          <div className="pt-[12px]">
            <div className="w-full font-body font-medium text-[13px] text-white">
              Sub-Heading
            </div>
            <div className="w-full h-[46px] pt-1 rounded-2xl">
              <Subheading
                onChange={(val) => {
                  handleChange("subheading", val);
                }}
                value={getValue( options?.subheading )}
                onFocusOut={saveOptions}
              />
            </div>
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel  inline-block group  cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Alignment</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Choose between a single column or a double column layout.
            </span>
          </div>
          <div className="optionSectionContent">
            <Radio
              options={[
                { icon: DoubleColumn, value: true },
                { icon: SingleColumn, value: false },
              ]}
              value={options?.double_columns}
              onChange={(val) => {
                handleChange("double_columns", val);
                saveOptions();
              }}
              label={options?.double_columns ? "Double Column" : "Single Column"}
              withIcon
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Text Alignment</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the visual spacing and dividing lines between roles and
              names.
            </span>
          </div>
          <div className="optionSectionContent">
            <Radio
              options={[
                {
                  icon: options?.double_columns
                    ? gutterJustify
                    : SingleColumnCenter,
                  value: options?.double_columns ? "gutter" : "center",
                },
                {
                  icon: LeftAlignment2,
                  value: "left",
                  // disabled: !options.double_columns,
                },

                {
                  icon: RightAlignment2,
                  value: "right",
                  // disabled: !options.double_columns,
                },
                {
                  icon: JustifiedAlignment3,
                  value: "justify",
                  disabled: !options?.double_columns,
                },
                {
                  icon: RaggedAlignment,
                  value: "ragged",
                  disabled: !options?.double_columns,
                },
              ]}
              value={
                options?.double_columns && options?.text_alignment === "center"
                  ? "gutter"
                  : options?.double_columns &&
                      options?.text_alignment === "justify"
                    ? "justify"
                    : options?.text_alignment
              }
              onChange={(val) => {
                handleChange("text_alignment", val);
                saveOptions();
              }}
              label={
                options?.double_columns && options?.text_alignment === "center"
                  ? "Gutter"
                  : !options?.double_columns
                    ? options?.text_alignment === "center"
                      ? "Center"
                      : options?.text_alignment === "left"
                        ? "Left"
                        : "Right"
                    : options?.text_alignment
              }
              withIcon
            />
          </div>
        </div>

        <div className="optionSection ">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Arrangement</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Set the number of columns to arrange the credits in.
            </span>
          </div>

          <div className="optionSectionContent">
            <NumberInput
              label="Column(s)"
              postLabel=""
              value={options?.columns}
              onChange={(val) => handleChange("columns", val)}
              min={1}
              max={2}
              onFocusOut={saveOptions}
              disabled={options?.bullets !== null}
              // customBtnMargin={{ marginLeft: "68px" }}
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Width</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the horizontal width of the credit block as a percentage.
            </span>
          </div>

          <div className="optionSectionContent">
            <NumberInput
              label="Full"
              postLabel="%"
              value={options?.column_width}
              onChange={(val) =>
                handleChange(
                  "column_width",
                  conditionalColumnWidth(val, options),
                )
              }
              min={30}
              max={100}
              onFocusOut={saveOptions}
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Order</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Choose whether to display roles or names first..
            </span>
          </div>
          <div className="optionSectionContent">
            <Radio
              options={[
                { icon: RoleFirst, value: false },
                { icon: NamesFirst, value: true },
              ]}
              value={options?.name_on_left}
              onChange={(val) => {
                handleChange("name_on_left", val);
                saveOptions();
              }}
              label={options?.name_on_left ? "Names First" : "Roles First"}
              withIcon
            />
          </div>
        </div>

        {/* <hr className="border-b-2 border-[#e0e0e0]" /> */}

        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Block Inset</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the horizontal indentation and padding of the block.
            </span>
          </div>
          <div className="optionSectionContent block-option-content BLock-inset ">
            <Radio
              label={options?.block_inset}
              options={[
                {
                  icon: InsetOff,
                  value: "default",
                  disabled:
                    options?.side_by_side === "on" &&
                    (options?.block_inset === "default" ||
                      options?.block_inset === "left" ||
                      options?.block_inset === "right"),
                },
                {
                  icon: InsetLeft,
                  value: "left",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: InsetRight,
                  value: "right",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: SideAB,
                  value: "sidebyside",
                  disabled: options?.side_by_side === "on",
                },
              ]}
              value={options?.block_inset}
              onChange={(val) => {
                handleChange("block_inset", val);
                saveOptions();
              }}
              withIcon
            />
          </div>
        </div>

        {!options?.double_columns && (
          <div className="optionSection ">
            <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
              <span className="cursor-help">Gap</span>
              <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                Add space between after every pair of Role-Name.
              </span>
            </div>

            <div className="optionSectionContent">
              {/* <span className="bg-gray" style={{color: "#fff", fontSize: "18px", marginRight: "8px", }}>&darr;</span> */}
               <NumberInput_fontsize
                  label="Row"
                  step="1"
                  min={1}
                  max={30}
                  value={fontStyle?.marginBottom ?? 0}
                  onChange={handleMarginBottomChange}
                  inputBox
                  customWidth={"max-w-[100px]"}
                />
            </div>
          </div>
        )}

        {!isCard && (
          <div>
            <div className="optionSection">
              <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                <span className="cursor-help">Margin</span>
                <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                  Adjust the vertical margin around the credit block.
                </span>
              </div>
              <div className="optionSectionContent block-option-content">
                <div className="label-2 label-2-roleName1440">Vertical</div>
                <Dropdown
                  // label="Vertical"
                  options={option}
                  selectedID={selectedID}
                  value={options?.margin_vertical}
                  onChange={(val) => {
                    handleChange("margin_vertical", val);
                    saveOptions();
                  }}
                />
              </div>
            </div>

            <div className="optionSection">
              <div className="optionSectionContent2 block-option-content">
                <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                  <span className="cursor-help">Bottom</span>
                  <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                    Adjust the extra spacing directly below the credit block.
                  </span>
                </div>
                <NumberInput
                  label={<><span className="bg-gray" style={{color: "#fff", fontSize: "18px", marginRight: "8px", }}>&darr;</span></>}
                  value={options?.extra_lines_below}
                  min={0}
                  max={25}
                  onChange={(val) => handleChange("extra_lines_below", val)}
                  onFocusOut={saveOptions}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoleName;
